// src/pages/administrasi/ArsipDokumen.jsx
import { useEffect, useState, useCallback, useMemo } from "react";
import { API_BASE_URL } from "../../utils/config";
import CustomSelect from "../../components/CustomSelect";

const token = () => localStorage.getItem("accessToken");

async function apiFetch(url, opts = {}) {
  const res = await fetch(`${API_BASE_URL}${url}`, {
    ...opts,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token()}`,
      ...(opts.headers || {}),
    },
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.detail || JSON.stringify(data) || "Request failed");
  }
  return res.status === 204 ? null : res.json();
}

export default function ArsipDokumen() {
  const [events, setEvents] = useState([]);
  const [eventId, setEventId] = useState("");
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    apiFetch("/api/administrasi/events/?active_only=1")
      .then((data) => {
        const list = Array.isArray(data) ? data : data.results || [];
        setEvents(list);
        if (list.length) setEventId(String(list[0].id));
      })
      .catch((e) => setError(e.message));
  }, []);

  const loadFiles = useCallback(async () => {
    if (!eventId) {
      setFiles([]);
      return;
    }
    setLoading(true);
    setError("");
    try {
      const data = await apiFetch(
        `/api/administrasi/archive/?event_id=${eventId}&module=sekretaris`
      );
      setFiles(data.files || []);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [eventId]);

  useEffect(() => {
    loadFiles();
  }, [loadFiles]);

  const filteredFiles = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return files;
    return files.filter((f) => (f.name || "").toLowerCase().includes(q));
  }, [files, search]);

  return (
    <div>
      <div className="flex items-center justify-between mb-4 gap-4">
        <div>
          <h1 className="text-2xl font-semibold">Arsip Dokumen</h1>
          <p className="text-sm text-muted mt-1">
            Daftar file di folder Drive Sekretaris untuk event terpilih — termasuk file yang
            diunggah langsung di Drive, bukan cuma yang dibuat lewat aplikasi ini.
          </p>
        </div>
        <button
          onClick={loadFiles}
          className="shrink-0 text-xs font-medium text-brand-600 hover:text-brand-700"
        >
          Refresh
        </button>
      </div>

      <div className="glass-card p-4 mb-4">
        <label className="block text-xs font-medium mb-1">Event</label>
        <CustomSelect
          value={eventId}
          onChange={setEventId}
          options={events.map((ev) => ({ value: String(ev.id), label: ev.name }))}
          placeholder="-- Pilih event --"
        />
      </div>

      {error && <p className="text-sm text-red-600 mb-3">{error}</p>}
      {loading && <p className="text-sm text-muted mb-3">Loading...</p>}

      <div className="mb-3">
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Cari nama file…"
          className="w-full max-w-sm rounded-md border border-white/50 dark:border-white/15 px-3 py-2 text-sm"
        />
      </div>

      <div className="space-y-2">
        {filteredFiles.map((f) => (
          <a
            key={f.id}
            href={f.web_view_link}
            target="_blank"
            rel="noreferrer"
            className="glass-card p-3 flex items-center gap-3 hover:bg-white/20 transition-colors"
          >
            {f.icon_link && <img src={f.icon_link} alt="" className="w-5 h-5 shrink-0" />}
            <div className="min-w-0 flex-1">
              <div className="text-sm font-medium truncate">{f.name}</div>
              <div className="text-xs text-muted">
                {f.modified_time ? new Date(f.modified_time).toLocaleString("id-ID") : ""}
              </div>
            </div>
          </a>
        ))}
        {!loading && files.length === 0 && !error && (
          <p className="text-sm text-muted">Tidak ada file di folder ini.</p>
        )}
        {!loading && files.length > 0 && filteredFiles.length === 0 && (
          <p className="text-sm text-muted">Tidak ada file yang cocok dengan pencarian.</p>
        )}
      </div>
    </div>
  );
}
